export const messages = {
  en: {
    finishHousekeepingPool: {
      title: 'Finish Housekeeping Pool',
      serviceCharge: 'Service Charge',
      workOrderCompletion: 'Work Order Completion',
      feeCategory: 'Fee Category',
      feeName: 'Fee Name',
      chargeAmount: 'Charge Amount',
      actualAmount: 'Actual Amount',
      status: 'Status',
      operation: 'Operation',
      selectFee: 'Select Fee',
      delete: 'Delete',
      processingComments: 'Processing Comments',
      beforeProcessingImages: 'Before Processing Images',
      afterProcessingImages: 'After Processing Images',
      submit: 'Submit',
      back: 'Back',
      required: 'Required',
      selectServiceFee: 'Select Service Fee',
      computingFormula: 'Computing Formula',
      amount: 'Amount',
      choose: 'Choose'
    }
  },
  zh: {
    finishHousekeepingPool: {
      title: '完成家政服务工单',
      serviceCharge: '项目收费',
      workOrderCompletion: '工单结单',
      feeCategory: '费用大类',
      feeName: '费用名称',
      chargeAmount: '收费金额',
      actualAmount: '实收金额',
      status: '状态',
      operation: '操作',
      selectFee: '选择费用',
      delete: '删除',
      processingComments: '处理意见',
      beforeProcessingImages: '处理前图片',
      afterProcessingImages: '处理后图片',
      submit: '提交',
      back: '返回',
      required: '必填',
      selectServiceFee: '选择服务费用',
      computingFormula: '计算公式',
      amount: '金额',
      choose: '选择'
    }
  }
}